const Question_Secret = process.env.ANSWER_ENCRYPTION_KEY || "TUTUORIA_%@_*80_Secret";

export const getMasteryStatus = (score) => {
  if (score >= 90) return "mastered";
  if (score > 60 && score < 90) return "in-progress";
  if (score <= 60) return "not-started";
  return "not-started";
};

export const getMasteryText = (score) => {
  if (score >= 90) return "Champion";
  if (score > 60 && score < 90) return "Challenger";
  return "Rookie";
};

export const createArrayFromId = (id) => {
  return [id];
};

const IV_LENGTH = 12; // must match the backend's IV_LENGTH

async function deriveKey(secret) {
  const encoder = new TextEncoder();
  const secretBytes = encoder.encode(secret);
  const hashBuffer = await window.crypto.subtle.digest("SHA-256", secretBytes);
  return window.crypto.subtle.importKey(
    "raw",
    hashBuffer,
    { name: "AES-GCM" },
    false,
    ["decrypt"]
  );
}

function base64ToBytes(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

export async function decryptValue(payload, secret) {
  if (payload === null || payload === undefined) return payload;

  const key = await deriveKey(secret);
  const bytes = base64ToBytes(payload);

  const iv = bytes.slice(0, IV_LENGTH);
  // Web Crypto expects ciphertext + auth tag concatenated together — this
  // matches the [iv][ciphertext][authTag] layout produced by the backend.
  const data = bytes.slice(IV_LENGTH);

  const decryptedBuffer = await window.crypto.subtle.decrypt(
    { name: "AES-GCM", iv },
    key,
    data
  );

  const decoder = new TextDecoder();
  const json = decoder.decode(decryptedBuffer);
  return JSON.parse(json);
}

export async function decryptQuestions(questions, isFullLength = false) {
  const secret =  Question_Secret
  return Promise.all(
    questions.map(async (question) => {
    const questionOptions = question.options
    if(question.type === 'numerical' && isFullLength) {
      questionOptions[0].value = await decryptValue(questionOptions[0].value, secret)
    }
    return {
      ...question,
      answer_index: await decryptValue(question.answer_index, secret),
      correct_answers: await decryptValue(question.correct_answers, secret),
      options: questionOptions
    }})
  );
}

export async function decryptIELTSQuestions(questions) {
  const secret =  Question_Secret
  return Promise.all(
    questions.map(async (question) => {
   
      return {
        ...question,
        answer_index: await decryptValue(question.answer_index, secret),
        options: await decryptValue(question.options, secret)
      }
    })
  );
}

export async function decryptAssessment(assessment) {
  const decryptedSections = await Promise.all(
    (assessment.sections || []).map(async (section) => {
      let rulesData = {}
      if(section.rule) {
        rulesData = {
          rule: {
            ...section.rule,
            conditions: await Promise.all((section.rule.conditions || []).map(async condition => {
              return {
                ...condition,
                questions: await decryptQuestions(condition.questions || [], true),
              }
            }))
          }
        }
      }
      return {
      ...section,
      questions: await decryptQuestions(section.questions || [], true),
      ...rulesData,
    }})
  );
 
  return { ...assessment, sections: decryptedSections };
}

export async function decryptIELTSAssessment(assessment) {
  const decryptedSections = await Promise.all(
    (assessment.sections || []).map(async (section) => {
      if(section.type === 'LISTENING') {
        return {
          ...section,
          parts: await Promise.all((section.parts || []).map(async part => {
            return {
              ...part,
              questions: await decryptIELTSQuestions(part.questions || []),
            }
          }))
        }
      }
      if(section.type === 'READING') {
        return {
          ...section,
          passages: await Promise.all((section.passages || []).map(async passage => {
            return {
              ...passage,
              parts: await Promise.all((passage.parts || []).map(async part => {
                return {
                  ...part,
                  questions: await decryptIELTSQuestions(part.questions || []),
                }
              }))
            }
          }))
        }
      }
      return {
      ...section,
    }})
  );
 
  return { ...assessment, sections: decryptedSections };
}